import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerFooterClick = props => {
  const datalayerFooterClickHandler = event => {
    const validClasses = [
      "footer-menu__link",
      "ter-footer__logo",
      "ter-footer__callout",
      "ter-footer__social-link",
      "ter-footer__legal-stuff-link",
    ]

    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      let href = event.target.getAttribute("href") || null
      let navLinkText =
        event.target.innerText ||
        event.target.textContent ||
        event.target.getAttribute("aria-label") ||
        null
      window.dataLayer.push({
        event: "nav_click",
        click_label: navLinkText,
        click_url: href,
        nav_location: "footer",
        nav_level: 1,
        total_nav_levels: 1,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query =
      document?.querySelectorAll(
        ".footer-menu__link, .ter-footer__logo, .ter-footer__callout, .ter-footer__social-link, .ter-footer__legal-stuff-link"
      ).length > 0
  }
  useClickListener(datalayerFooterClickHandler, query)
}

export default DatalayerFooterClick
